var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-author"},[_c('div',{staticClass:"about-author__legend"},[_vm._v("\n    Автор "+_vm._s(_vm.userName)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"about-author__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }